import PropTypes from "prop-types";
import classnames from "classnames";
import CSVReader from "react-csv-reader";

import Label from "../Label";
import { FormControl } from "../Form";
import FormInput from "../FormInput";
import Icon from "../../Icon";

import "./fileUploader.scss";

const FileUploader = ({ name, label, className, onUpload, disabled }) => {
  return (
    <FormControl>
      <FormInput type="upload" className={classnames(className)}>
        <Label htmlFor={name} aria-label={label}>
          <div className="file-upload__faker" aria-hidden="true">
            <Icon name="system-arrow-up" theme="brand" size="small" />
            <span>{label}</span>
          </div>
          <CSVReader
            accept=".csv"
            disabled={disabled}
            name={name}
            inputId={name}
            parserOptions={{ skipEmptyLines: true }}
            onFileLoaded={(data, fileInfo) => onUpload(data, fileInfo)}
          />
        </Label>
      </FormInput>
    </FormControl>
  );
};

FileUploader.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  onUpload: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default FileUploader;
